import { Keuzehulp } from '../keuzehulpen'

const hevigMenstrueelBloedverlies: Keuzehulp = {
  title: 'Hevig menstrueel bloedverlies',
  basePath: '/hevig-menstrueel-bloedverlies',
  documentTitle: 'Hevig menstrueel bloedverlies',
  routes: [
    {
      path: '',
      routeId: 'P5-001',
      nextRouteId: 'P5-002',
      type: 'intro',
      title: 'Voordat je begint…',
      backButton:
        'https://www.thuisarts.nl/keuzehulp/ik-verlies-veel-bloed-als-ik-ongesteld-ben-wat-is-er-mogelijk',
      columns: [
        {
          title: 'Neem de tijd',
          description: 'Neem alle tijd die je nodig hebt om de keuzehulp in te vullen',
        },
        {
          title: '20 tot 25 minuten',
          description: 'Zo lang doen de meeste mensen over deze keuzehulp',
        },
        {
          title: 'Zoek een rustig plekje',
          description: 'Zodat je je zonder afleiding kunt concentreren',
        },
        {
          title: 'Download uw gegevens',
          description: 'Aan het einde kun je je antwoorden bekijken en printen',
        },
      ],
    },
    {
      path: '/stap-1',
      routeIndex: '1',
      routeId: 'P5-002',
      nextRouteId: 'P5-003',
      type: 'chapter',
      title: 'Wat is veel bloedverlies als je ongesteld bent?',
      subtitle: 'Stap 1',
      description:
        'Hoeveel bloed je verliest, is niet voor alle mensen hetzelfde. In deze stap leggen we uit wat veel bloedverlies is.',
      image: {
        src: `${process.env.PUBLIC_URL}/img/hmb-stap-1.jpg`,
        alt: '',
      },
      button: 'Ga verder',
    },
    {
      path: '/stap-1/wat-is-veel-bloedverlies-tijdens-het-ongesteld-zijn',
      routeId: 'P5-003',
      nextRouteId: 'P5-004',
      type: 'explanation',
      align: 'left',
      titleAlign: 'center',
      title: 'Wat is veel bloedverlies als je ongesteld bent?',
      description: `
        <h2 style="margin-bottom: 0; font-size: 18px; line-height: 1.6;">Ongesteld zijn</h2>
        <p style="margin-top: 0;">Aan de binnenkant van de baarmoeder zit een dun laagje slijm. Dit noemen we slijmvlies. In het slijmvlies zitten bloedvaatjes.</p>
        <p>Elke maand wordt het slijmvlies in je baarmoeder dikker. Dit is bedoeld voor een bevruchte eicel. Is er geen bevruchte eicel? Dan ruimt je lichaam het slijmvlies op.</p>
        <p>Er komt dan bloed uit je vagina. Dit is ongesteld zijn.</p>
        <h2 style="margin-bottom: 0; font-size: 18px; line-height: 1.6;">Veel bloedverlies</h2>
        <p style="margin-top: 0;">Hoeveel bloed je verliest, is niet voor alle mensen hetzelfde. Je bloedverlies kan ook veranderen tijdens je leven. Duurt het langer of verlies je meer bloed dan je gewend bent? Dan noemen we dat veel bloedverlies.</p>
        <p>
          Je merkt dit bijvoorbeeld aan 1 of meer van deze dingen:
          <ul style="margin-top: 0">
          <li>Je moet maandverband, tampons of een cup vaker vervangen.</li>
          <li>Je maandverband, tampon of cup is steeds helemaal vol en kan gaan lekken. Je lekt dan door. </li>
          <li>Je hebt extra bescherming nodig. Je moet bijvoorbeeld een tampon of cup en maandverband tegelijk gebruiken.</li>
          <li>Je verliest grote klonten bloed.</li>
          <li>Je bent langer ongesteld dan je gewend bent.</li>
          <li>Je hebt buikpijn.</li>
          <li>Je hebt last van het bloedverlies in de dingen die je elke dag doet. Deze dingen kun je bijvoorbeeld niet meer doen:
            <ul style="margin-top: 0">
              <li>werken of sporten.</li>
              <li>naar buiten gaan om iets te doen</li>
            </ul>
          </li>
          </ul>
        </p>
        <h2 style="margin-bottom: 0; font-size: 18px; line-height: 1.6;">Bloedarmoede</h2>
        <p style="margin-top: 0;">
          Verlies je veel bloed? Dan kun je bloedarmoede krijgen. Bij bloedarmoede brengt je bloed minder zuurstof naar je lichaam. Je merkt dit aan 1 of meer van deze klachten:
          <ul style="margin-top: 0">
            <li>Moe zijn.</li>
            <li>Je voelt je hart in je keel of borst kloppen (hartkloppingen).</li>
            <li>Duizelig zijn.</li>
            <li>Moeilijker of sneller ademen als je iets doet, zoals sporten.</li>
          </ul>
          Denk je dat je bloedarmoede hebt? Vraag aan je arts of het nodig is om je bloed te laten onderzoeken op bloedarmoede.
        </p>
        <h2 style="margin-bottom: 0; font-size: 18px; line-height: 1.6;">Waar komt het door</h2>
        <p style="margin-top: 0;">Soms vindt je arts een oorzaak voor veel bloedverlies. Bijvoorbeeld een ziekte van je baarmoeder. Of als je medicijnen gebruikt die zorgen voor meer bloedverlies, zoals bloedverdunners. Of als je een koperspiraal hebt.</p>
        <p>Soms vindt je arts geen oorzaak voor veel bloedverlies. Je klachten kunnen dan komen door ouder worden.  Of door aanleg, bijvoorbeeld als veel mensen in je familie veel bloedverlies hebben.</p>
      `,
      button: 'Volgende',
    },
    {
      path: '/stap-1/welke-behandelingen-zijn-er',
      routeId: 'P5-004',
      nextRouteId: 'P5-005',
      type: 'explanation',
      title: 'Welke behandelingen zijn er?',
      align: 'left',
      titleAlign: 'center',
      description: `
        <p>
          Verlies je veel bloed als je ongesteld bent? Dan kun je verschillende behandelingen krijgen:
          <ul style="margin-top: 0">
            <li>Niet behandelen</li>
            <li>Medicijnen zonder hormonen</li>
            <li>De pil om niet zwanger te worden (anticonceptie-pil, of gewoon ‘de pil’)</li>
            <li>Hormoonspiraal</li>
            <li>Operatie: baarmoeder-slijmvlies weghalen</li>
            <li>Operatie: baarmoeder weghalen</li>
          </ul>
        </p>
        <p><strong>Let op</strong>: wil je nog kinderen? Dan is een operatie niet geschikt voor jou.</p>
        <p><strong>Let op</strong>: meestal kun je pas voor een operatie kiezen als je eerder andere behandelingen hebt geprobeerd.</p>
        <p>Je bespreekt samen met je arts welke behandelingen voor jou geschikt zijn. Soms is de ene behandeling voor jou duidelijk beter dan de andere behandelingen. Soms maakt het niet uit. Dan kun je kiezen.</p>
    `,
      button: 'Volgende',
    },
    {
      path: '/stap-1/vraag-1',
      routeId: 'P5-005',
      nextRouteId: 'P5-006',
      type: 'question',
      hideFromOverview: true,
      title: 'Waar wil je meer over weten?',
      description:
        'Vink aan waarover jij meer wilt weten. Vink alle opties aan als je over elke behandeling meer wilt weten.',
      descriptionAlign: 'left',
      questions: [
        {
          type: 'multiple',
          answers: [
            {
              title: 'Niet behandelen',
              showChapter: '2',
            },
            {
              title: 'Medicijnen zonder hormonen',
              showChapter: '3',
            },
            {
              title: 'De pil om niet zwanger te worden (anticonceptie-pil, of gewoon ‘de pil’)',
              showChapter: '4',
            },
            {
              title: 'Hormoonspiraal',
              showChapter: '5',
            },
            {
              title: 'Operatie: baarmoeder-slijmvlies weghalen',
              showChapter: '6',
            },
            {
              title: 'Operatie: baarmoeder weghalen',
              showChapter: '7',
            },
          ],
        },
      ],
      button: 'Volgende',
    },
    {
      path: '/stap-2',
      routeIndex: '2',
      routeId: 'P5-006',
      nextRouteId: 'P5-007',
      type: 'chapter',
      title: 'Niet behandelen',
      subtitle: 'Stap 2',
      description:
        'Veel bloed verliezen als je ongesteld bent is meestal niet gevaarlijk. Heb je weinig klachten? </br> Dan kun je kiezen voor niet behandelen.',
      image: {
        src: `${process.env.PUBLIC_URL}/img/hmb-stap-2.jpg`,
        alt: '',
      },
      button: 'Ga verder',
    },
    {
      path: '/stap-2/niet-behandelen',
      routeId: 'P5-007',
      nextRouteId: 'P5-008',
      type: 'explanation',
      align: 'left',
      titleAlign: 'Center',
      title: 'Niet behandelen',
      description: `
        <h2 style="margin-bottom: 0; font-size: 18px; line-height: 1.6;">Welk resultaat kun je verwachten als je kiest voor niet behandelen?</h2>
        <p style="margin-top: 0;">
          Je weet niet hoe het verdergaat met je klachten. Je klachten kunnen erger worden. Maar dat hoeft niet. Je klachten kunnen ook hetzelfde blijven of minder worden. Na de overgang stopt het bloedverlies. Je hebt dan geen klachten meer.
        </p>
        <h2 style="margin-bottom: 0; font-size: 18px; line-height: 1.6;">Risico's van niet behandelen</h2>
        <h3 style="margin: 0; font-size: 18px; line-height: 1.6;">Bloedarmoede</h3>
        <p style="margin-top: 0;">Je kunt bloedarmoede krijgen als je elke maand heel veel bloed verliest. Je kunt hier ijzerpillen voor slikken. Dit helpt tegen bloedarmoede door bloedverlies.</p>
        <h3 style="margin: 0; font-size: 18px; line-height: 1.6;">Als je klachten blijven</h3>
        <p style="margin-top: 0;">Blijf je last houden van je klachten? Of worden je klachten erger? Dan kun je later altijd nog een behandeling kiezen. Je bent dan niet te laat.</p>
        <h2 style="margin-bottom: 0; font-size: 18px; line-height: 1.6;">Voordelen van niet behandelen</h2>
        <p style="margin: 0">
          <ul style="margin: 0">
            <li>Je hoeft niet naar een arts.</li>
            <li>Je hoeft niets te slikken.</li>
            <li>Je hoeft niet naar het ziekenhuis of naar je huisarts voor een behandeling.</li>
            <li>Je hebt geen bijwerkingen of risico’s van een behandeling.</li>
            <li>Wil je later toch nog een behandeling? Dan kan dat.</li>
          </ul>
        </p>
        <h2 style="margin-bottom: 0; font-size: 18px; line-height: 1.6;">Nadelen van niet behandelen</h2>
        <p style="margin: 0">
          <ul style="margin: 0">
            <li>Je klachten gaan niet weg.</li>
            <li>Je klachten kunnen erger worden. Maar dat hoeft niet.</li>
            <li>Je kunt bloedarmoede krijgen.</li>
          </ul>
        </p>
      `,
      button: 'Volgende',
    },
    {
      path: '/stap-3',
      routeIndex: '3',
      routeId: 'P5-008',
      nextRouteId: 'P5-009',
      type: 'chapter',
      title: 'Medicijnen zonder hormonen',
      subtitle: 'Stap 3',
      description:
        'Medicijnen zonder hormonen slik je op de 3 dagen dat je het meeste bloed verliest. </br> Deze medicijnen zorgen ervoor dat je minder bloed verliest.',
      image: {
        src: `${process.env.PUBLIC_URL}/img/hmb-stap-3.jpg`,
        alt: '',
      },
      button: 'Ga verder',
    },
    {
      path: '/stap-3/medicijnen-zonder-hormonen',
      routeId: 'P5-009',
      nextRouteId: 'P5-010',
      type: 'explanation',
      align: 'left',
      titleAlign: 'center',
      title: 'Medicijnen zonder hormonen',
      description: `
        <p>Medicijnen zonder hormonen slik je op de 3 dagen dat je het meeste bloed verliest. Deze medicijnen zorgen ervoor dat je minder bloed verliest.</p>
        <p style="margin-bottom: 0">Je kunt deze medicijnen krijgen:
          <ul>
            <li>Pijnstillers zoals ibuprofen, naproxen of diclofenac (NSAID’s)</li>
            <li>Tranexaminezuur</li>
          </ul>
        </p>
        <h2 style="margin-bottom: 0; font-size: 18px; line-height: 1.6;">Pijnstillers zoals ibuprofen, naproxen of diclofenac</h2>
        <p style="margin-top: 0">Deze pijnstillers zorgen ervoor dat je minder pijn hebt. En minder bloedverlies. Je slikt 2 of 3 keer per dag pillen. Je spreekt met je arts af hoeveel pillen je precies slikt. Je slikt de medicijnen niet langer dan 3 dagen.</p>
        <p>Je kunt deze medicijnen kopen bij de drogist of apotheek. Je hebt daarvoor geen recept van je arts nodig.</p>
        <p>Deze pijnstillers zijn meestal <strong>niet geschikt</strong> als je 1 of meer van deze dingen hebt:
          <ul>
            <li>Maagklachten. Soms kun je een medicijn erbij krijgen dat je maag beschermt. Je arts bespreekt dit met je.</li>
            <li>Sommige darmziektes, zoals de ziekte van Crohn of colitis ulcerosa.</li>
            <li>Problemen met je hart, lever of nieren.</li>
            <li>Een maagverkleining.</li>
          </ul>
        </p>
        <p>Deze pijnstillers gaan vaak niet goed samen met andere medicijnen. Gebruik je andere medicijnen? Vraag dan aan je huisarts of apotheek of je deze pijnstillers mag gebruiken.</p>

        <h2 style="margin-bottom: 0; font-size: 18px; line-height: 1.6;">Tranexaminezuur</h2>
        <p style="margin-top: 0">Dit medicijn zorgt ervoor dat je bloed beter stolt. Hierdoor verlies je minder bloed als je ongesteld bent.</p>
        <p>Je slikt 3 keer per dag 2 pillen. Je slikt de medicijnen niet langer dan 3 dagen.</p>
        <p>Dit medicijn is <strong>niet geschikt</strong> als je 1 of meer van deze dingen hebt:
        <ul>
          <li>Een grotere kans op een bloedprop in een ader (trombose).</br> Bijvoorbeeld als jij zelf of mensen in je familie een bloedprop in een ader hebben gehad.</li>
          <li>Ernstige nierproblemen.</li>
        </ul>
        <p>Je arts bekijkt samen met jou of tranexaminezuur in jouw situatie geschikt is.</p>

        <p>Je kunt ook pijnstillers en tranexaminezuur tegelijk slikken.</p>

        <h2 style="margin-bottom: 0; font-size: 18px; line-height: 1.6;"> Medicijnen zonder hormonen en zwangerschap</h2>
        <p style="margin-top: 0">Je kunt nog steeds zwanger worden als je deze medicijnen slikt. Je moet wel stoppen met deze medicijnen als je zwanger bent, omdat deze medicijnen waarschijnlijk niet goed zijn voor je baby.</p>

        <h2 style="margin-bottom: 0; font-size: 18px; line-height: 1.6;">Kosten</h2>
        <p style="margin-top: 0">Pijnstillers worden niet vergoed door je zorgverzekeraar. Je moet ze dus zelf betalen.</p>
        <p>Tranexaminezuur wordt wel vergoed door je zorgverzekeraar. Je betaalt alleen je eigen risico.</p>
      `,
      button: 'Volgende',
    },
    {
      path: '/stap-3/resulaten-medicijnen-zonder-hormonen',
      routeId: 'P5-010',
      nextRouteId: 'P5-011',
      type: 'explanation',
      align: 'left',
      titleAlign: 'center',
      title: 'Welk resultaat kun je verwachten als je medicijnen zonder hormonen slikt?',
      description: `
        <h2 style="margin-bottom: 0; font-size: 18px; line-height: 1.6;">Pijnstillers zoals ibuprofen, naproxen en diclofenac</h2>
        <p style="margin-top: 0;">Deze pijnstillers werken goed tegen de pijn. Ook heb je waarschijnlijk minder bloedverlies.</p>
        <p>Alle poppetjes samen zijn 100 mensen met veel bloedverlies die pijnstillers slikken.</p>
        <p>Groene poppetjes: bij 25 van de 100 mensen is het bloedverlies veel minder. </br> Rode poppetjes: bij 75 van de 100 mensen is het bloedverlies niet minder of maar een beetje minder.</p>
        <div class="img-wrapper"><img src="${process.env.PUBLIC_URL}/img/hmb-population_green_25_red_75.png" alt=""/></div>

        <h2 style="margin-bottom: 0; font-size: 18px; line-height: 1.6;">Tranexaminezuur</h2>
        <p style="margin-top: 0;">Tranexaminezuur werkt beter tegen veel bloedverlies dan pijnstillers. Tranexaminezuur zorgt <strong>niet</strong> voor minder pijn.</p>
        <p>Alle poppetjes samen zijn 100 mensen met veel bloedverlies die tranexaminezuur slikken.</p>
        <p>Groene poppetjes: bij 50 van de 100 is het bloedverlies veel minder. </br> Rode poppetjes: bij 50 van de 100 mensen is het bloedverlies niet minder of maar een beetje minder.</p>
        <div class="img-wrapper"><img src="${process.env.PUBLIC_URL}/img/hmb-population_green_50_red_50.png" alt=""></div>
      `,
      button: 'Volgende',
    },
    {
      path: '/stap-3/bijwerkingen-van-medicijnen-zonder-hormonen',
      routeId: 'P5-011',
      nextRouteId: 'P5-012',
      type: 'explanation',
      align: 'left',
      titleAlign: 'center',
      title: 'Bijwerkingen van medicijnen zonder hormonen',
      description: `
        <p>De meeste mensen krijgen geen bijwerkingen. </p>
        <p>Je kunt deze bijwerkingen krijgen:</p>
        <h2 style="margin-bottom: 0; font-size: 18px; line-height: 1.6;">Pijnstillers zoals ibuprofen, naproxen en diclofenac</h2>
        <ul>
          <li>
            Last van je maag of darmen. Alle poppetjes samen zijn 100 mensen die pijnstillers gebruiken. </br></br> Rode poppetjes: 5 van de 100 mensen krijgen last van hun maag of darmen. Bijvoorbeeld diarree, brandend maagzuur, misselijk zijn of een opgeblazen gevoel in je buik. </br> Groene poppetjes: 95 van de 100 mensen krijgen <strong>geen</strong> last van hun maag of darmen.
            <div class="img-wrapper"><img src="${process.env.PUBLIC_URL}/img/hmb-population_red_5_green_95.png" alt=""/></div>
          </li>
          <li>Bloeding in je maag of darmen. De kans op een bloeding hangt af van welke pijnstiller je gebruikt.</li>
        </ul>

        <h2 style="margin-bottom: 0; font-size: 18px; line-height: 1.6;">Tranexaminezuur</h2>
        <ul>
          <li>
            Last van je maag of darmen. Alle poppetjes samen zijn 100 mensen die tranexaminezuur gebruiken. </br></br> Rode poppetjes: 5 van de 100 mensen krijgen last van hun maag of darmen. Bijvoorbeeld misselijk zijn of diarree. </br> Groene poppetjes: 95 van de 100 mensen krijgen <strong>geen</strong> last van hun maag of darmen.
            <div class="img-wrapper"><img src="${process.env.PUBLIC_URL}/img/hmb-population_red_5_green_95.png" alt="" /></div>
          </li>
        </ul>
      `,
      button: 'Volgende',
    },
    {
      path: '/stap-3/voordelen-en-nadelen-medicijnen-zonder-hormonen',
      routeId: 'P5-012',
      nextRouteId: 'P5-013',
      type: 'explanation',
      align: 'left',
      titleAlign: 'center',
      title: 'Voordelen en nadelen van medicijnen zonder hormonen',
      description: `
        <h2 style="margin-bottom: 0; font-size: 18px; line-height: 1.6;">Voordelen van medicijnen zonder hormonen</h2>
        <ul>
          <li>Je verliest waarschijnlijk minder bloed.</li>
          <li>Pijnstillers zorgen ervoor dat je minder pijn hebt.</li>
          <li>Je kunt pijnstillers kopen zonder recept van je arts.</li>
          <li>Je hoeft maar een paar dagen in de maand medicijnen te slikken, niet elke dag.</li>
        </ul>

        <h2 style="margin-bottom: 0; font-size: 18px; line-height: 1.6;">Nadelen van medicijnen zonder hormonen</h2>
        <ul>
          <li>Je moet elke maand medicijnen slikken op de dagen dat je het meeste bloed verliest.</li>
          <li>Je hebt een kans op bijwerkingen van de medicijnen.</li>
          <li>Pijnstillers worden niet vergoed door je zorgverzekeraar. </br> Voor tranexaminezuur betaal je je eigen risico.</li>
        </ul>
        `,
      button: 'Volgende',
    },
    {
      path: '/stap-4',
      routeIndex: '4',
      routeId: 'P5-013',
      nextRouteId: 'P5-014',
      type: 'chapter',
      title: 'De pil om niet zwanger te worden (anticonceptie-pil)',
      subtitle: 'Stap 4',
      description:
        'Bij deze behandeling slik je de pil om niet zwanger te worden (de pil). De pil zorgt ervoor dat je minder pijn hebt als je ongesteld bent. En dat je minder bloed verliest.',
      image: {
        src: `${process.env.PUBLIC_URL}/img/hmb-stap-4.jpg`,
        alt: '',
      },
      button: 'Ga verder',
    },
    {
      path: '/stap-4/anticonceptie-pil',
      routeId: 'P5-014',
      nextRouteId: 'P5-015',
      type: 'explanation',
      title: 'De pil om niet zwanger te worden (anticonceptie-pil)',
      description: `
        <p>Bij deze behandeling slik je de pil om niet zwanger te worden (de pil). De pil zorgt ervoor dat je minder pijn hebt als je ongesteld bent. En dat je minder bloed verliest. Als je de pil slikt, kun je niet zwanger worden. </p>
        <p>Voor de pil heb je een recept nodig van je arts.</p>

        <p>De pil is niet voor iedereen geschikt. Je kunt de pil bijvoorbeeld niet slikken als je 1 of meer van deze dingen hebt:
          <ul>
            <li>Je rookt en bent ouder dan 35.</li>
            <li>Je rookt en hebt last van migraine met aura. </br> Bij migraine aura zie je met beide ogen een vlek in beeld. Ook kun je een tintelend gevoel hebben in je lip of in 1 hand. Daarna kun je hoofdpijn krijgen.</li>
            <li>Je hebt borstkanker of je hebt borstkanker gehad.</li>
            <li>Je hebt een bloedprop in een bloedvat (trombose) gehad, of een bloedprop in een bloedvat van de long (longembolie).</li>
            <li>Je hebt een hartinfarct of een beroerte gehad.</li>
          </ul>
        </p>

        <p>Bespreek met je arts of de pil geschikt is voor jou.</p>

        <h2 style="margin-bottom: 0; font-size: 18px; line-height: 1.6;">Hormonen in de pil</h2>
        <p style="margin-top: 0;">In de pil zitten 2 hormonen: oestrogeen en progesteron. Je slikt 1 keer per dag 1 pil. Meestal slik je de pil een aantal maanden elke dag. Bijvoorbeeld 3 maanden. Je wordt dan niet ongesteld. Dit noemen we doorslikken van de pil. Dit is niet gevaarlijk.</p>
        <p>Na een aantal maanden stop je met slikken en word je wel ongesteld. Dit is met minder bloedverlies dan je gewend bent. Daarna slik je de pil weer een aantal maanden.</p>
        <p>Je kunt ook kiezen om de pil elke maand 1 week niet te slikken. Dan word je dus elke maand ongesteld. Kies wat het beste bij jou past.</p>
        %MODALLINK%

        <h2 style="margin-bottom: 0; font-size: 18px; line-height: 1.6;">Kosten</h2>
        <p style="margin-top: 0;">Ben je jonger dan 21 jaar? Dan vergoedt je zorgverzekeraar de pil. Vanaf 18 jaar betaal je wel je eigen risico.</p>
        <p>Ben je 21 jaar of ouder? Dan krijg je de pil niet vergoed vanuit de basis-verzekering. Heb je een aanvullende verzekering? Dan vergoedt je zorgverzekeraar de pil soms wel. Vraag dit na bij je zorgverzekeraar.</p>
        `,
      modalLink: 'Zwangerschap ',
      modalHeader: 'Zwangerschap ',
      modalText: `<p>Vergeet je de pil nooit? Dan is de kans dat je zwanger wordt heel klein. Stop je met de pil? Dan kun je weer zwanger worden.</p>`,
      align: 'left',
      titleAlign: 'center',
      button: 'Volgende',
    },
    {
      path: '/stap-4/resultaten-anticonceptie-pil',
      routeId: 'P5-015',
      nextRouteId: 'P5-016',
      type: 'explanation',
      title: 'Welk resultaat kun je verwachten als je de pil slikt om niet zwanger te worden?',
      description: `
        <p>Je verliest minder bloed. Vaak heb je ook minder pijn.</p>
        <p>Alle poppetjes samen zijn 100 mensen met veel bloedverlies die de pil slikken.</p>
        <p>Groene poppetjes: bij 50 van de 100 mensen is het bloedverlies veel minder.</br> Rode poppetjes: bij 50 van de 100 mensen is het bloedverlies niet minder of maar een beetje minder.</p>
        <div class="img-wrapper"><img src="${process.env.PUBLIC_URL}/img/hmb-population_green_50_red_50.png" alt="" /></div>
      `,
      align: 'left',
      titleAlign: 'center',
      button: 'Volgende',
    },
    {
      path: '/stap-4/bijwerkingen-anticonceptie-pil',
      routeId: 'P5-016',
      nextRouteId: 'P5-017',
      type: 'explanation',
      title: 'Bijwerkingen van de pil',
      description: `
        <p>Je kunt deze bijwerkingen krijgen:
          <ul>
            <li>Hoe je je voelt verandert steeds (stemmings-wisselingen)</li>
            <li>Somber zijn</li>
            <li>Hoofdpijn</li>
            <li>Misselijk zijn</li>
            <li>Bloed verliezen via je vagina als je niet ongesteld bent</li>
            <li>Gevoelige of pijnlijke borsten</li>
            <li>Zwaarder worden</li>
          </ul>
          Je hebt hier meestal vooral last van in de eerste weken of maanden.
        </p>

        <h2 style="margin-bottom: 0; font-size: 18px; line-height: 1.6;">Bloedprop in een bloedvat</h2>
        <p style="margin-top: 0;">Je hebt een iets grotere kans op een bloedprop in een bloedvat (trombose). Bijvoorbeeld in je been of in je longen.</p>
        <p>Je kunt dit merken aan deze dingen:
          <ul>
            <li>Een pijnlijk, dik en warm been</li>
            <li>Benauwd zijn</li>
          </ul>
        </p>

        `,
      align: 'left',
      titleAlign: 'center',
      button: 'Volgende',
    },
    {
      path: '/stap-4/voordelen-en-nadelen-anticonceptie-pil',
      routeId: 'P5-017',
      nextRouteId: 'P5-018',
      type: 'explanation',
      title: 'Voordelen en nadelen van de pil',
      description: `
        <h2 style="margin-bottom: 0; font-size: 18px; line-height: 1.6;">Voordelen van de pil</h2>
        <ul>
          <li>Je verliest minder bloed.</li>
          <li>Je hebt helemaal geen bloedverlies als je de pil elke dag slikt zonder te stoppen.</li>
          <li>Je hebt vaak minder pijn.</li>
          <li>De pil beschermt goed tegen zwanger worden.</li>
        </ul>
        <h2 style="margin-bottom: 0; font-size: 18px; line-height: 1.6;">Nadelen van de pil</h2>
        <ul>
          <li>Je moet elke dag een pil slikken.</li>
          <li>Je kunt bijwerkingen van de pil krijgen.</li>
          <li>De pil kost geld.</li>
        </ul>
        `,
      align: 'left',
      titleAlign: 'center',
      button: 'Volgende',
    },
    {
      path: '/stap-5',
      routeIndex: '5',
      routeId: 'P5-018',
      nextRouteId: 'P5-019',
      type: 'chapter',
      title: 'Hormoonspiraal',
      subtitle: 'Stap 5',
      description:
        'Een hormoonspiraal is een klein plastic ankertje. Er zit 1 hormoon in. Hierdoor verlies je waarschijnlijk veel minder bloed.',
      image: {
        src: `${process.env.PUBLIC_URL}/img/hmb-stap-5.jpg`,
        alt: '',
      },
      button: 'Ga verder',
    },
    {
      path: '/stap-5/hormoonspiraal',
      routeId: 'P5-019',
      nextRouteId: 'P5-020',
      type: 'explanation',
      title: 'Hormoonspiraal',
      align: 'left',
      titleAlign: 'center',
      description: `
        <p> Een hormoonspiraal is een klein plastic ankertje. Er zit 1 hormoon in: progestageen.</p>
        <p>Je arts brengt de spiraal via de vagina in je baarmoeder. Dit kan pijn doen. De spiraal werkt 5 tot 8 jaar. Je kunt een nieuwe spiraal krijgen als het bloedverlies weer erger wordt. </p>
        <div class="img-wrapper"><img src="${process.env.PUBLIC_URL}/img/hmb-hormoonspiraal.png" alt="Hormoonspiraal" title="Hormoonspiraal"/></div>

        %MODALLINK%

        <h2 style="margin-bottom: 0; font-size: 18px; line-height: 1.6;">Kosten</h2>
        <p style="margin-top: 0;">Ben je jonger dan 21 jaar? Dan vergoedt je zorgverzekeraar de hormoonspiraal. Vanaf 18 jaar betaal je wel je eigen risico.</p>
        <p>Ben je 21 jaar of ouder? Dan krijg je de hormoonspiraal niet vergoed vanuit de basis-verzekering. Heb je een aanvullende zorgverzekering? Dan vergoedt je zorgverzekeraar de spiraal soms wel. Vraag dit na bij je zorgverzekeraar.</p>

        <h2 style="margin-bottom: 0; font-size: 18px; line-height: 1.6;">Kosten voor plaatsen</h2>
        <p style="margin-top: 0;">Je moet misschien ook betalen voor het plaatsen van de spiraal. Het plaatsen van de spiraal door de huisarts is gratis. Bij het plaatsen van de spiraal door de gynaecoloog betaal je vanaf 18 jaar je eigen risico. Je arts of zorgverzekeraar kan je meer vertellen over de kosten.</p>

        `,
      modalLink: 'Zwanger worden ',
      modalHeader: 'Zwanger worden ',
      modalText: `<p>Heb je een spiraal? Dan is de kans heel klein dat je zwanger wordt. De spiraal werkt 8 jaar tegen zwanger worden. Besluit je later dat je zwanger wilt worden? Dan kan je arts de spiraal eruit halen en kun je weer zwanger worden.</p>`,
      button: 'Volgende',
    },
    {
      path: '/stap-5/resultaten-hormoonspiraal',
      routeId: 'P5-020',
      nextRouteId: 'P5-021',
      type: 'explanation',
      title: 'Welk resultaat kun je verwachten als je een hormoonspiraal hebt?',
      titleAlign: 'center',
      align: 'left',
      description: `
        <h2 style="margin-bottom: 0; font-size: 18px; line-height: 1.6;">Veel minder bloedverlies</h2>
        <p style="margin-top: 0;">Je verliest waarschijnlijk veel minder bloed. Vaak heb je ook minder pijn.</p>
        <p>Alle poppetjes samen zijn 100 mensen met veel bloedverlies die een hormoonspiraal hebben.</p>
        <p>Groene poppetjes: Bij 90 van de 100 mensen is het bloedverlies veel minder. </br> Rode poppetjes: Bij 10 van de 100 mensen wordt het bloedverlies niet minder of maar een beetje minder.</p>
        <div class="img-wrapper"><img src="${process.env.PUBLIC_URL}/img/hmb-population_green_90_red_10.png" alt=""/></div>

        <h2 style="margin-bottom: 0; font-size: 18px; line-height: 1.6;">Niet meer ongesteld</h2>
        <p style="margin-top: 0;">Misschien word je zelfs helemaal niet meer ongesteld.</p>
        <p>Alle poppetjes samen zijn 100 mensen met veel bloedverlies die een hormoonspiraal hebben.</p>
        <p>Groene poppetjes: 60 van de 100 mensen worden niet meer ongesteld na 2 jaar. </br> Rode poppetjes: 40 van de 100 mensen worden na 2 jaar nog steeds ongesteld.</p>
        <div class="img-wrapper"><img src="${process.env.PUBLIC_URL}/img/hmb-population_green_60_red_40.png" alt=""/></div>
      `,
      button: 'Volgende',
    },
    {
      path: '/stap-5/bijwerkingen-en-risicos-hormoonspiraal',
      routeId: 'P5-021',
      nextRouteId: 'P5-022',
      type: 'explanation',
      title: 'Bijwerkingen en risico’s van de hormoonspiraal',
      titleAlign: 'center',
      align: 'left',
      description: `
        <h2 style="margin-bottom: 0; font-size: 18px; line-height: 1.6;">Bijwerkingen</h2>
        <p style="margin-top: 0;">Je kunt 1 of meer van deze bijwerkingen krijgen:
        <ul>
          <li>een beetje bloed verliezen op momenten dat je het niet verwacht</li>
          <li>hoofdpijn</li>
          <li>pijn in je borsten</li>
          <li>puistjes</li>
          <li>haaruitval</li>
          <li>somber zijn</li>
          <li>meer vocht uit de vagina (afscheiding)</li>
        </ul>
        Deze bijwerkingen gaan meestal binnen 3 maanden vanzelf weg.</p>

        <h2 style="margin-bottom: 0; font-size: 18px; line-height: 1.6;">Spiraal gaat door de baarmoeder heen</h2>
        <p style="margin-top: 0;">Heel soms gaat bij het plaatsen de spiraal door de baarmoeder heen. De spiraal komt dan in de buik terecht. De arts moet dan de spiraal weghalen via een klein sneetje in de buik.</p>
        <p>Alle poppetjes samen zijn 100 mensen die een hormoonspiraal krijgen.</p>
        <p>Rode poppetjes: Bij 1 van de 1000 (duizend) mensen die een spiraal krijgen gaat de spiraal door de baarmoeder heen. </br> Groene poppetjes: Bij 999 van de 1000 (duizend) mensen gaat de spiraal <strong>niet</strong> door de baarmoeder heen.</p>
        <div class="img-wrapper"><img src="${process.env.PUBLIC_URL}/img/hmb-population_red_0.5_green_99.5.png" alt=""/></div>

        <h2 style="margin-bottom: 0; font-size: 18px; line-height: 1.6;">Spiraal komt los uit de baarmoeder</h2>
        <p style="margin-top: 0;">De spiraal kan ook loskomen uit de baarmoeder en uit de vagina vallen. De kans hierop is groter als je een cup gebruikt tijdens het ongesteld zijn.</p>

        <p>Komt de spiraal los? Dan kun je nog een keer een spiraal krijgen. Of je kunt voor een andere behandeling kiezen.</p>
        <p>Alle poppetjes samen 100 mensen die een hormoonspiraal krijgen.</p>
        <p>Rode poppetjes: Bij 4 van de 100 mensen komt de spiraal los uit de baarmoeder.</br> Groene poppetjes: Bij 96 van de 100 mensen blijft de spiraal in de baarmoeder zitten.</p>
        <div class="img-wrapper"><img src="${process.env.PUBLIC_URL}/img/hmb-population_red_4_green_96.png" alt=""/></div>
      `,
      button: 'Volgende',
    },
    {
      path: '/stap-5/voordelen-en-nadelen-hormoonspiraal',
      routeId: 'P5-022',
      nextRouteId: 'P5-023',
      type: 'explanation',
      title: 'Voordelen en nadelen van de hormoonspiraal',
      titleAlign: 'center',
      align: 'left',
      description: `
        <h2 style="margin-bottom: 0; font-size: 18px; line-height: 1.6;">Voordelen</h2>
        <ul>
          <li>Je verliest meestal veel minder bloed of helemaal geen bloed meer.</li>
          <li>Je hebt vaak minder pijn.</li>
          <li>Je hoeft niet te denken aan pillen slikken.</li>
          <li>De spiraal beschermt goed tegen zwanger worden.</li>
        </ul>

        <h2 style="margin-bottom: 0; font-size: 18px; line-height: 1.6;">Nadelen van de hormoonspiraal</h2>
        <ul>
          <li>Het plaatsen kan pijn doen.</li>
          <li>In de eerste 3 maanden kun je bijwerkingen hebben.</li>
          <li>Er is een kleine kans dat de spiraal verkeerd geplaatst wordt. Of dat de spiraal loskomt uit je baarmoeder.</li>
          <li>Je kunt geen cup gebruiken als je ongesteld bent.</li>
          <li>De spiraal kost geld.</li>
        </ul>
        `,
      button: 'Volgende',
    },
    {
      path: '/stap-6/operatie',
      routeIndex: '6',
      routeId: 'P5-023',
      nextRouteId: 'P5-024',
      type: 'chapter',
      title: 'Operatie: weghalen van het baarmoeder-slijmvlies',
      subtitle: 'Stap 6',
      description:
        'Bij deze behandeling haalt je arts je baarmoeder-slijmvlies weg. Hierdoor verlies je waarschijnlijk veel minder bloed als je ongesteld bent.',
      image: {
        src: `${process.env.PUBLIC_URL}/img/hmb-stap-6.jpg`,
        alt: '',
      },
      button: 'Ga verder',
    },
    {
      path: '/stap-6/operatie-weghalen-baarmoederslijmvlies',
      routeId: 'P5-024',
      nextRouteId: 'P5-025',
      type: 'explanation',
      title: 'Operatie: weghalen van het baarmoeder-slijmvlies',
      description: `
        <p>Bij deze behandeling haalt de arts je baarmoeder-slijmvlies weg.</p>

        <p><strong>Let op:</strong> deze operatie is niet voor iedereen geschikt:
          <ul>
            <li>Een arts die veel weet over je baarmoeder (gynaecoloog) onderzoekt of je deze operatie kunt krijgen.</li>
            <li>Wil je nog kinderen? Dan is deze operatie niet geschikt voor jou. Zwanger worden na deze operatie is gevaarlijk voor jou en je baby. Daarom is het belangrijk dat je na de operatie niet meer zwanger wordt.</li>
          </ul>
        </p>

        <h2 style="margin-bottom: 0; font-size: 18px; line-height: 1.6;">Verdoving</h2>
        <p style="margin-top: 0;">Voor deze operatie krijg je een verdoving. Welke verdoving je kunt krijgen, hangt af van het ziekenhuis waar je de operatie krijgt. Samen met je arts kies je welke verdoving je wilt:
          <ul>
            <li>Je arts verdooft met prikken het begin van je baarmoeder: je baarmoeder-hals. Je bent dan wakker tijdens de operatie, maar je voelt geen pijn of minder pijn.</li>
            <li>Je krijgt een medicijn waar je ontspannen of slaperig van wordt. Daardoor merk je minder of niets van de operatie. Meestal krijg je dit medicijn via een slangetje in je bloedvat (infuus).</li>
            <li>Je krijgt een prik in je rug. In de prik zit een verdoving waardoor je niets meer voelt in je onderlichaam. Je bent dan wakker tijdens de operatie, maar je voelt geen pijn.</li>
            <li>Je wordt met medicijnen in slaap gebracht. Dit heet narcose. Je merkt daardoor niets van de operatie.</li>
          </ul>
        </p>

        <h2 style="margin-bottom: 0; font-size: 18px; line-height: 1.6;">De operatie</h2>
        <p style="margin-top: 0;">Via je vagina schuift je arts een dun buisje in je baarmoeder. Door dit buisje haalt de arts je baarmoeder-slijmvlies weg. Dit duurt ongeveer 2 minuten.</p>
        <p>Krijg je prikken om de baarmoeder-hals te verdoven of medicijnen waardoor je slaperig wordt? Dan kun je tijdens de operatie pijn voelen in je onderbuik. De pijn duurt niet langer dan 2 minuten.</p>

        <div class="img-wrapper"><img src="${process.env.PUBLIC_URL}/img/hmb-slijmvlies.jpg" alt="Slijmvlies" title="Slijmvlies"/></div>

        <h2 style="margin-bottom: 0; font-size: 18px; line-height: 1.6;">Na de operatie</h2>
        <p style="margin-top: 0;">Je mag dezelfde dag weer naar huis. Ook mag je meteen weer de dingen doen die je elke dag doet. Soms heb je nog een beetje pijn na de operatie. Dan kun je niet meteen alles weer doen.</p>
        <p>Je kunt bloed of bruin slijm verliezen na de operatie. Dit kan 3 weken duren. Zolang je bloed verliest, mogen deze dingen niet:
          <ul>
            <li>Je mag niet in bad, zwemmen of naar de sauna.</li>
            <li>Er mag niets in de vagina komen. Zoals bij seks. Je mag ook geen tampons gebruiken.</li>
          </ul>
        Tot 6 weken na de operatie kun je nog last hebben van waterig vocht uit je vagina (afscheiding).</p>

        <h2 style="margin-bottom: 0; font-size: 18px; line-height: 1.6;">Niet zwanger worden</h2>
        <p style="margin-top: 0;">Na deze operatie is een zwangerschap gevaarlijk voor jou en je baby. Je kunt nog wel zwanger worden maar het is belangrijk dat je niet meer zwanger wordt. </p>
        <p>Gebruik daarom een voorbehoed-middel tot na de overgang.  Praat erover met je arts. Samen kun je kijken welk voorbehoed-middel in jouw situatie geschikt is. Na deze operatie kun je <strong>geen</strong> spiraal krijgen.</p>

        <h2 style="margin-bottom: 0; font-size: 18px; line-height: 1.6;">Kosten</h2>
        <p style="margin-top: 0;">Je zorgverzekeraar vergoedt de operatie. Je betaalt wel je eigen risico.</p>
      `,
      align: 'left',
      titleAlign: 'center',
      button: 'Volgende',
    },
    {
      path: '/stap-6/resultaten-operatie-weghalen-baarmoederslijmvlies',
      routeId: 'P5-025',
      nextRouteId: 'P5-026',
      type: 'explanation',
      title: 'Welk resultaat kun je verwachten na het weghalen van je baarmoeder-slijmvlies?',
      description: `
        <h2 style="margin-bottom: 0; font-size: 18px; line-height: 1.6;">Veel minder bloedverlies</h2>
        <p style="margin-top: 0;">Je verliest waarschijnlijk veel minder bloed.</p>
        <p>Alle poppetjes samen zijn 100 mensen bij wie het baarmoeder-slijmvlies is weggehaald.</p>
        <p>Groene poppetjes: Bij 90 van de 100 mensen wordt het bloedverlies veel minder. </br> Rode poppetjes: Bij 10 van de 100 mensen wordt het bloedverlies niet minder of maar een beetje minder.</p>
        <div class="img-wrapper"><img src="${process.env.PUBLIC_URL}/img/hmb-population_green_90_red_10.png" alt=""/></div>

        <h2 style="margin-bottom: 0; font-size: 18px; line-height: 1.6;">Niet meer ongesteld</h2>
        <p style="margin-top: 0;">Misschien word je zelfs helemaal niet meer ongesteld.</p>
        <p>Alle poppetjes samen zijn 100 mensen bij wie het baarmoeder-slijmvlies is weggehaald.</p>
        <p>Groene poppetjes: 70 van de 100 mensen worden niet meer ongesteld na 2 jaar. </br> Rode poppetjes: 30 van de 100 mensen worden na 2 jaar nog steeds ongesteld.</p>
        <div class="img-wrapper"><img src="${process.env.PUBLIC_URL}/img/hmb-population_green_70_red_30.png" alt="" /></div>

        <h2 style="margin-bottom: 0; font-size: 18px; line-height: 1.6;">Pijn</h2>
        <p style="margin-top: 0;">Het is niet te voorspellen of je na de operatie minder pijn hebt als je ongesteld bent. Bij sommige mensen wordt de pijn juist erger.</p>
        <p>Heb je al veel pijn als je ongesteld bent? Dan is de kans groter dat je na de operatie nog meer pijn hebt.</p>
        <p>Worden je klachten niet minder na het weghalen van je baarmoeder-slijmvlies? Dan kun je altijd nog kiezen om je hele baarmoeder weg te laten halen.</p>
      `,
      align: 'left',
      titleAlign: 'center',
      button: 'Volgende',
    },
    {
      path: '/stap-6/risicos-operatie-weghalen-baarmoederslijmvlies',
      routeId: 'P5-026',
      nextRouteId: 'P5-027',
      type: 'explanation',
      title: 'Risico’s van je baarmoeder-slijmvlies weghalen',
      description: `
        <p>Een operatie om je baarmoeder-slijmvlies weg te halen, heeft deze risico’s:
          <ul>
            <li>Een bloedprop in een bloedvat in je been (trombose)</li>
            <li>Een ontsteking, bijvoorbeeld van je baarmoeder</li>
            <li>Een bloeding in je baarmoeder</li>
            <li>Een gaatje in je baarmoeder. Je arts moet dan stoppen met de operatie.</li>
          </ul>
        </p>

        <p>Alle poppetjes samen zijn 100 mensen bij wie hun baarmoeder-slijmvlies is weggehaald.</p>
        <p>Rode poppetjes: 2 van de 100 mensen krijgen 1 of meer van deze problemen tijdens of na de operatie. </br> Groene poppetjes: 98 van de 100 mensen krijgen geen problemen tijdens of na de operatie.</p>
        <div class="img-wrapper"><img src="${process.env.PUBLIC_URL}/img/hmb-population_red_2_green_98.png" alt=""/></div>
      `,
      align: 'left',
      titleAlign: 'center',
      button: 'Volgende',
    },
    {
      path: '/stap-6/voordelen-en-nadelen-operatie-weghalen-baarmoederslijmvlies',
      routeId: 'P5-027',
      nextRouteId: 'P5-028',
      type: 'explanation',
      title: 'Voordelen en nadelen van het weghalen van je baarmoeder-slijmvlies weghalen',
      description: `
        <h2 style="margin-bottom: 0; font-size: 18px; line-height: 1.6;">Voordelen van je baarmoeder-slijmvlies weghalen</h2>
        <ul>
          <li>Je verliest waarschijnlijk veel minder bloed.</li>
          <li>Je hebt een kans dat je bloedverlies helemaal stopt.</li>
          <li>Je herstelt sneller dan wanneer je baarmoeder helemaal wordt weggehaald.</li>
        </ul>

        <h2 style="margin-bottom: 0; font-size: 18px; line-height: 1.6;">Nadelen van je baarmoeder-slijmvlies weghalen</h2>
        <ul>
          <li>Je hebt na deze operatie misschien meer pijn als je ongesteld bent.</li>
          <li>Je hebt een kans dat er iets misgaat tijdens de operatie.</li>
          <li>Je moet herstellen na de operatie.</li>
          <li>Je mag niet meer zwanger worden.</li>
        </ul>
      `,
      align: 'left',
      titleAlign: 'center',
      button: 'Volgende',
    },
    {
      path: '/stap-7',
      routeIndex: '7',
      routeId: 'P5-028',
      nextRouteId: 'P5-029',
      type: 'chapter',
      title: 'Operatie: baarmoeder weghalen',
      subtitle: 'Stap 7',
      description:
        'Je arts kan je baarmoeder weghalen met een operatie. Je wordt dan nooit meer ongesteld. Het bloedverlies stopt helemaal.',
      image: {
        src: `${process.env.PUBLIC_URL}/img/hmb-stap-7.jpg`,
        alt: '',
      },
      button: 'Ga verder',
    },
    {
      path: '/stap-7/operatie-weghalen-van-de-baarmoeder',
      routeId: 'P5-029',
      nextRouteId: 'P5-030',
      type: 'explanation',
      title: 'Operatie: baarmoeder weghalen',
      align: 'left',
      titleAlign: 'center',
      description: `
        <p>Je arts kan je baarmoeder weghalen met een operatie. Dit heet een hysterectomie. Meestal blijven je eierstokken wel zitten. Je komt dan niet in de overgang.</p>
        <p><strong>Let op:</strong> Je kunt na deze operatie niet meer zwanger worden. Wil je nog kinderen? Dan is deze behandeling niet geschikt voor jou.</p>

        <h2 style="margin-bottom: 0; font-size: 18px; line-height: 1.6;">De operatie</h2>
        <p style="margin-top: 0;">De meeste mensen krijgen een kijk-operatie via de buik. Je arts brengt dan via kleine sneetjes slangetjes in je buik. Soms word je geopereerd via je vagina of maakt je arts een grotere snee in je buik. Dit hangt af van deze dingen:
          <ul>
            <li>Hoe groot je baarmoeder is</li>
            <li>Of je eerder een operatie hebt gehad in je buik</li>
          </ul>
          Je arts bespreekt met je welke manier voor jou het meest geschikt is.
        </p>

        <h2 style="margin-bottom: 0; font-size: 18px; line-height: 1.6;">Na de operatie</h2>
        <h3 style="margin: 0; font-size: 18px; line-height: 1.6;">Kijk-operatie</h3>
        <p style="margin-top: 0;">Meestal blijf je 1 nacht in het ziekenhuis. Soms mag je dezelfde dag nog naar huis.</p>
        <p>De eerste week mag je niet zwaar tillen. Sommige mensen hebben daarom hulp nodig. Bijvoorbeeld met het huishouden of zorgen voor hun kinderen.</p>
        <p>Meestal kun je na een paar dagen weer rustig beginnen met sporten. De meeste mensen zijn na 4 weken helemaal hersteld. Tot 6 weken na de operatie mag je geen seks hebben waarbij er iets in je vagina komt.</p>

        <h3 style="margin-bottom: 0; font-size: 18px; line-height: 1.6;">Operatie via een grotere snee in je buik</h3>
        <p style="margin-top: 0;">Je blijft meestal 2 of 3 dagen in het ziekenhuis.</p>
        <p>De eerste 2 weken mag je niet zwaar tillen. Sommige mensen hebben daarom hulp nodig. Bijvoorbeeld met het huishouden of zorgen voor hun kinderen.</p>
        <p>Meestal kun je na 2 weken weer rustig beginnen met sporten. Tot 6 weken na de operatie mag je geen seks hebben waarbij er iets in je vagina komt. De meeste mensen zijn na 6 weken helemaal hersteld.</p>

        <h2 style="margin-bottom: 0; font-size: 18px; line-height: 1.6;">Kosten</h2>
        <p style="margin-top: 0;">Je zorgverzekeraar vergoedt deze operatie. Je betaalt wel je eigen risico.</p>
      `,

      info: [
        {
          urlText: 'Lees meer over een kijk-operatie',
          title: 'Kijk-operatie',
          content: `<div>
            <p>Je wordt eerst met medicijnen in slaap gebracht (narcose). Je merkt dan niets van de operatie.</p>
            <p>Daarna maakt de arts een paar kleine sneetjes in je buik. Deze sneetjes zijn 1 tot 2 centimeter.</p>
            <p>Door de sneetjes brengt de arts slangetjes in je buik. Aan de slangetjes zitten een camera en gereedschap, zoals een tangetje. Je arts haalt je baarmoeder weg via de sneetjes of via je vagina. Daarna worden de wondjes gehecht. Dit worden kleine littekens.</p>
            <p>De operatie duurt meestal 1,5 of 2 uur.</p>
            <div class="img-wrapper"><img src="${process.env.PUBLIC_URL}/img/hmb-kijkoperatie.jpg" alt="Slijmvlies" title="Kijkoperatie"/></div>
          </div>`,
        },
        {
          urlText: 'Lees meer over een operatie via een grotere snee in je buik ',
          title: 'Operatie via een grotere snee in je buik ',
          content: `<div>
            <p>Je krijgt eerst een verdoving. Je kunt twee soorten verdovingen krijgen:
              <ul>
                <li>Je krijgt een prik in je rug. In de prik zit een verdoving waardoor je niets meer voelt in je onderlichaam. Je bent dan wakker tijdens de operatie, maar je voelt geen pijn.</li>
                <li>Je wordt met medicijnen in slaap gebracht (narcose). Je merkt dan niets van de operatie.</li>
              </ul>
              Daarna maakt de arts een snee van ongeveer 10 centimeter onderin je buik (plaatje). Meestal is dit een snee van links naar rechts. Dit noemen we een bikini-snee. Soms is de snee van boven naar onder. Dit noemen we een verticale snee.
            </p>
            <p>Je arts haalt je baarmoeder weg via de snee. Daarna wordt de wond gehecht. Dit wordt een litteken.</p>
            <p>De operatie duurt meestal 1,5 of 2 uur.</p>
            <div class="img-wrapper"><img src="${process.env.PUBLIC_URL}/img/hmb-operatie-via-grote-snee.jpg" alt="Slijmvlies" title="Operatie via een grotere snee in je buik"/></div>
          </div>`,
        },
      ],
      button: 'Volgende',
    },
    {
      path: '/stap-7/resultaten-weghalen-van-de-baarmoeder',
      routeId: 'P5-030',
      nextRouteId: 'P5-031',
      type: 'explanation',
      title: 'Welk resultaat kun je verwachten van je baarmoeder weghalen?',
      align: 'left',
      titleAlign: 'center',
      description: `
        <p>Je wordt nooit meer ongesteld. Het bloedverlies stopt helemaal.</p>
        <p>Heb je pijn als je ongesteld bent? Meestal is deze pijn na de operatie weg. Soms komt je buikpijn door iets anders dan ongesteld zijn. Bijvoorbeeld door problemen met je darmen. Dan gaat je pijn soms niet helemaal weg.</p>
      `,
      button: 'Volgende',
    },
    {
      path: '/stap-7/risicos-weghalen-van-de-baarmoeder',
      routeId: 'P5-031',
      nextRouteId: 'P5-032',
      type: 'explanation',
      title: 'Risico’s van je baarmoeder weghalen',
      align: 'left',
      titleAlign: 'center',
      description: `
        <h2 style="margin: 0; font-size: 18px; line-height: 1.6;">Risico’s tijdens of kort na de operatie</h2>
        <p style="margin-top: 0;">De operatie heeft deze risico’s:
          <ul>
            <li>Een bloedprop in een bloedvat in je been (trombose)</li>
            <li>Een ontsteking, bijvoorbeeld van de wond of je blaas</li>
            <li>Schade aan je blaas of darm</li>
            <li>Een bloeding uit de operatiewond</li>
          </ul>
        </p>

        <p>Alle poppetjes samen zijn 100 mensen met veel bloedverlies als ze ongesteld zijn en bij wie de baarmoeder is weggehaald.</p>
        <p>Rode poppetjes: 5 van de 100 mensen krijgen 1 of meer van deze problemen tijdens of na de operatie. </br> Groene poppetjes: 95 van de 100 mensen krijgen geen problemen tijdens of na de operatie.</p>

        <div class="img-wrapper"><img src="${process.env.PUBLIC_URL}/img/hmb-population_red_5_green_95.png" alt=""/></div>

        <p>Heel soms heb je na de operatie problemen met plassen, seks of de overgang. Dit is meestal tijdelijk.</p>

        <h2 style="margin: 0; font-size: 18px; line-height: 1.6;">Tijdelijke overgangs-klachten</h2>
        <p style="margin-top: 0;">Je kunt na de operatie tijdelijk klachten krijgen die lijken op de overgang. Bijvoorbeeld warmte-aanvallen (opvliegers) en ’s nachts zweten. Dat komt doordat er door de operatie even minder bloed naar de eierstokken gaat. Daardoor kunnen de eierstokken minder goed werken. Meestal gaan deze overgangs-klachten na een paar maanden vanzelf weer weg.</p>
      `,
      button: 'Volgende',
    },
    {
      path: '/stap-7/voordelen-en-nadelen-weghalen-van-de-baarmoeder',
      routeId: 'P5-032',
      nextRouteId: 'P5-033',
      type: 'explanation',
      title: 'Voordelen en nadelen van je baarmoeder weghalen',
      align: 'left',
      titleAlign: 'center',
      description: `
        <h2 style="margin: 0; font-size: 18px; line-height: 1.6;">Wat zijn de voordelen van je baarmoeder weghalen?</h2>
        <ul>
          <li>Je bloedverlies stopt helemaal. Je wordt nooit meer ongesteld.</li>
          <li>Heb je pijn als je ongesteld bent? Dan is die na de operatie meestal verdwenen.</li>
        </ul>

        <h2 style="margin: 0; font-size: 18px; line-height: 1.6;">Wat zijn de nadelen van je baarmoeder weghalen?</h2>
        <ul>
          <li>Je hebt kans dat er iets misgaat tijdens de operatie.</li>
          <li>Je moet een paar weken herstellen na de operatie.</li>
          <li>Je kunt tijdelijk overgangs-klachten krijgen na de operatie.</li>
          <li>Je kunt geen kinderen meer krijgen.</li>
        </ul>
      `,
      button: 'Volgende',
    },
    {
      path: '/stap-8',
      routeIndex: '8',
      routeId: 'P5-033',
      nextRouteId: 'P5-034',
      type: 'chapter',
      title: 'Vergelijk de behandelingen',
      subtitle: 'Stap 8',
      description: 'Overzicht van alle behandelingen. Wat is voor jou belangrijk?',
      image: {
        src: `${process.env.PUBLIC_URL}/img/hmb-stap-8.jpg`,
        alt: '',
      },
      button: 'Ga verder',
    },
    {
      path: '/stap-8/vergelijk-de-behandelingen',
      routeId: 'P5-034',
      nextRouteId: 'P5-035',
      type: 'explanation',
      title: 'Vergelijk de behandelingen',
      description: `
        <table class="table-layout-fixed">
          <thead>
            <tr>
              <th></th>
              <th>Geen behandeling</th>
              <th>Medicijnen zonder hormonen</th>
              <th>De pil om niet zwanger te worden</th>
              <th>Hormoonspiraal</th>
              <th>Operatie </br>weghalen baarmoeder-slijmvlies</th>
              <th>Operatie </br>weghalen baarmoeder</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <th>Wat betekent het?</th>
              <td>Je krijgt geen behandeling.</td>
              <td>Je slikt medicijnen op de 3 dagen dat je het meeste bloed verliest.</td>
              <td>Je slikt elke dag 1 pil.</br>Na een aantal maanden slik je de pil 1 week niet. In deze week word je ongesteld. Daarna ga je de pil weer slikken.</td>
              <td>Je krijgt een klein plastic ankertje met 1 hormoon in je baarmoeder.</br>De spiraal kan 5 tot 8 jaar blijven zitten</td>
              <td>Je arts haalt je baarmoeder-slijmvlies weg met een operatie.</br>Gebruik een voorbehoed-middel tot na de overgang.</td>
              <td>Je arts haalt je baarmoeder weg met een operatie.</br>Je kunt geen kinderen meer krijgen.</td>
            </tr>
            <tr>
              <th>Hoeveel bloedverlies heb je na een behandeling?</th>
              <td>Je bloedverlies blijft hetzelfde.</br>Je klachten gaan weg na de overgang</td>
              <td>
                <b>Pijnstillers:</b>
                <br/>
                25 van de 100 mensen hebben veel minder bloedverlies.
                <br/>
                <b>Tranexaminezuur:</b>
                <br/>
                50 van de 100 mensen hebben veel minder bloedverlies
              </td>
              <td>
                50 van de 100 mensen hebben veel minder bloedverlies.
              </td>
              <td>90 van de 100 mensen hebben veel minder bloedverlies.</br>60 van de 100 mensen zijn niet meer ongesteld na 2 jaar.</td>
              <td>90 van de 100 mensen hebben veel minder bloedverlies.</br>70 van de 100 mensen zijn niet meer ongesteld na 2 jaar.</td>
              <td>Je wordt niet meer ongesteld. Je hebt dus geen bloedverlies meer.</td>
            </tr>
            <tr>
              <th>Hoeveel pijn heb je na een behandeling als je ongesteld bent?</th>
              <td>Je pijn blijft meestal hetzelfde.</td>
              <td>
                <b>Pijnstillers:</b>
                </br>
                meestal heb je minder pijn.
                <b>Tranexaminezuur:</b>
                </br>
                je pijn blijft hetzelfde.
              </td>
              <td>Meestal heb je minder pijn.</td>
              <td>Meestal heb je minder pijn.</td>
              <td>Je pijn wordt niet altijd minder. Soms wordt je pijn erger.</td>
              <td>Je hebt geen pijn meer.</br>Je kunt nog wel pijn hebben door iets anders dan ongesteld zijn.</td>
            </tr>
            <tr>
              <th>Wat zijn de bijwerkingen en risico’s?</th>
              <td>Bloedarmoede</td>
              <td>
                <b>Pijnstillers:</b>
                </br>
                Bij 5 van de 100 mensen: last van je maag of darmen.</br>Heel soms een bloeding in je maag of darmen.
                </br>
                <b>Tranexaminezuur:</b>
                </br>
                Bij 5 van de 100 mensen: last van je maag of darmen
              </td>
              <td>
                <b>Bijwerkingen (meestal vooral de eerste weken of maanden):</b>
                <ul>
                  <li>Hoe je je voelt, verandert steeds</li>
                  <li>Somber zijn</li>
                  <li>Hoofdpijn</li>
                  <li>Misselijk zijn</li>
                  <li>Bloed verliezen via je vagina als je niet ongesteld bent</li>
                  <li>Gevoelige of pijnlijke borsten</li>
                  <li>Zwaarder worden</li>
                  <li>Iets grotere kans op een bloedprop in een bloedvat (trombose)</li>
                </ul>
              </td>
              <td>
                <b>Bijwerkingen (meestal vooral de maanden):</b>
                <ul>
                  <li>Een beetje bloed verliezen op momenten dat je het niet verwacht</li>
                  <li>Hoofdpijn</li>
                  <li>Pijn in je borsten</li>
                  <li>Puistjes</li>
                  <li>Haar-uitval</li>
                  <li>Somber zijn</li>
                  <li>Meer vocht uit je vagina (afscheiding)</li>
                </ul>
                </br>
                <b>Risico's:</b>
                <ul>
                  <li>Bij 1 van de 1000 (duizend) mensen: spiraal komt door de baarmoeder heen</li>
                  <li>Bij 4 van de 100 mensen: spiraal komt los uit de baarmoeder</li>
                </ul>
              </td>
              <td>
                Bij 2 van de 100 mensen problemen zoals:
                <ul>
                  <li>een bloedprop in een bloedvat (trombose)</li>
                  <li>een ontsteking</li>
                  <li>een bloeding uit je baarmoeder</li>
                </ul>
              </td>
              <td>
                Bij 5 van de 100 mensen problemen zoals:
                <ul>
                  <li>een bloedprop in een bloedvat (trombose)</li>
                  <li>een ontsteking</li>
                  <li>schade aan je darm of blaas</li>
                  <li>een bloeding uit de operatiewond</li>
                </ul>
              </td>
            </tr>

          </tbody>
        </table>`,
      align: 'left',
      titleAlign: 'center',
      button: 'Volgende',
    },
    {
      path: '/stap-8/vergelijk-de-behandelingen-2',
      routeId: 'P5-035',
      nextRouteId: 'P5-036',
      type: 'explanation',
      title: 'Vergelijk de behandelingen',
      description: `
          <table class="table-layout-fixed">
            <thead>
              <tr>
                <th></th>
                <th>Geen behandeling</th>
                <th>Medicijnen zonder hormonen</th>
                <th>De pil om niet zwanger te worden</th>
                <th>Hormoonspiraal</th>
                <th>Operatie: <br />weghalen baarmoeder-slijmvlies</th>
                <th>Operatie: <br />weghalen baarmoeder</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <th>Voordelen</th>
                <td>Je hebt geen bijwerkingen of risico's van een behandeling.<br/>Wil je later toch nog een behandeling? Dan kan dat.</br>Na de overgang heb je geen klachten meer.</td>
                <td>
                  <b>Pijnstillers:</b>
                  </br>
                  Je hebt minder bloedverlies.<br/>Je hebt meestal minder pijn als je ongesteld bent.<br/>Je kunt pijnstillers kopen zonder recept.<br/>
                  <b>Tranexaminezuur:</b>
                  </br>
                  je hebt minder bloedverlies.
                </td>
                <td>Je hebt minder bloedverlies.<br/> Als je geen stopweek neemt, heb je helemaal geen bloedverlies.<br/>Je hebt vaak minder pijn als je ongesteld bent.<br/>De pil beschermt goed tegen zwanger worden.</td>
                <td>Je hebt meestal veel minder bloedverlies of helemaal geen bloedverlies meer.<br/>Je hebt vaak minder pijn als je ongesteld bent.<br/>Je hoeft geen pillen te slikken.<br/>Een spiraal beschermt goed tegen zwanger worden</td>
                <td>Je hebt veel minder bloedverlies of helemaal geen bloedverlies meer.<br/>Je herstelt sneller dan wanneer je baarmoeder helemaal wordt weggehaald.</td>
                <td>Je bloedverlies stopt helemaal.</br>Meestal heb je geen pijn meer.</td>
              </tr>
              <tr>
                <th>Nadelen</th>
                <td>Je klachten blijven hetzelfde.<br/> Je klachten kunnen ook erger worden.</td>
                <td>
                  <b>Pijnstillers:</b>
                  </br>
                  je slikt elke maand niet langer dan 3 dagen medicijnen.<br/> Pijnstillers worden niet vergoed door je zorgverzekeraar.<br/>
                  <b>Tranexaminezuur:</b>
                  </br>
                  je slikt elke maand niet langer dan 3 dagen medicijnen.
                </td>
                <td>Je slikt elke dag een pil.<br/>Kleine kans dat je nog steeds veel bloed verliest.<br/> Niet voor iedereen geschikt.<br/>Je zorgverzekeraar vergoedt de pil niet als je ouder dan 20 jaar bent. Als je een aanvullende verzekering hebt, vergoedt je zorgverzekeraar de pil soms wel.</td>
                <td>Het plaatsen van de spiraal kan pijn doen.</td>
                <td>Je moet herstellen na de operatie.<br/>Je mag niet meer zwanger worden.</td>
                <td>Je moet herstellen na de operatie.<br/>Je kunt geen kinderen meer krijgen.</td>
              </tr>
            </tbody>
          </table>
      `,
      align: 'left',
      titleAlign: 'center',
      button: 'Volgende',
    },
    {
      path: '/stap-8/test-je-kennis',
      routeId: 'P5-036',
      nextRouteId: 'P5-037',
      type: 'explanation',
      title: 'Test je kennis',
      align: 'left',
      titleAlign: 'center',
      description: `
        <p>Er volgen een aantal vragen. Ze gaan over de informatie in deze keuzehulp.</p>
        <p>Je kunt de vragen ook overslaan. Klik dan op ‘Volgende’.</p>
      `,
      button: 'Volgende',
    },
    {
      path: '/stap-8/vraag-1',
      routeId: 'P5-037',
      nextRouteId: 'P5-038',
      title: 'Wordt je bloedverlies altijd erger als je niets doet?',
      type: 'feedbackQuestion',
      feedbackAnswers: [
        {
          title: 'Ja',
          feedback: `<p>Het goede antwoord is nee. Je klachten kunnen erger worden, maar dat hoeft niet. Ze kunnen ook hetzelfde blijven of minder worden. Na de overgang heb je geen klachten meer.</p>`,
          correctOption: false,
        },
        {
          title: 'Nee',
          feedback: `<p>Dit is het goede antwoord. Je klachten kunnen erger worden, maar dat hoeft niet. Ze kunnen ook hetzelfde blijven of minder worden. Na de overgang heb je geen klachten meer.</p>`,
          correctOption: true,
        },
      ],
      button: 'Volgende',
    },
    {
      path: '/stap-8/vraag-2',
      routeId: 'P5-038',
      nextRouteId: 'P5-039',
      title: 'Moet je medicijnen zonder hormonen elke dag slikken? ',
      type: 'feedbackQuestion',
      feedbackAnswers: [
        {
          title: 'Ja',
          feedback: `<p>Het goede antwoord is nee. Je slikt deze medicijnen alleen op de dagen dat je het meeste bloed verliest.</p>`,
          correctOption: false,
        },
        {
          title: 'Nee',
          feedback: `<p>Dit is het goede antwoord. Je slikt deze medicijnen alleen op de dagen dat je het meeste bloed verliest.</p>`,
          correctOption: true,
        },
      ],
      button: 'Volgende',
    },
    {
      path: '/stap-8/vraag-3',
      routeId: 'P5-039',
      nextRouteId: 'P5-040',
      title:
        'Heb je met een hormoonspiraal minder bloedverlies dan met de pil om niet zwanger te worden? ',
      type: 'feedbackQuestion',
      feedbackAnswers: [
        {
          title: 'Ja',
          feedback: `<p>Dit is het goede antwoord. Met een hormoonspiraal heb je minder bloedverlies dan met de pil om niet zwanger te worden.</p>`,
          correctOption: true,
        },
        {
          title: 'Nee',
          feedback: `<p>Het goede antwoord is ja. Met een hormoonspiraal heb je minder bloedverlies dan met de pil om niet zwanger te worden.</p>`,
          correctOption: false,
        },
      ],
      button: 'Volgende',
    },
    {
      path: '/stap-8/vraag-4',
      routeId: 'P5-040',
      nextRouteId: 'P5-041',
      title: 'Kun je voor een operatie kiezen als je nog kinderen wilt?',
      type: 'feedbackQuestion',
      feedbackAnswers: [
        {
          title: 'Ja',
          feedback: `<p>Het goede antwoord is nee. Als je baarmoeder is weggehaald, kun je niet meer zwanger worden. Als je baarmoeder-slijmvlies is weggehaald, kun je nog wel zwanger worden. Maar dat is gevaarlijk voor jou en je baby. Gebruik daarom een voorbehoed-middel tot na de overgang.</p>`,
          correctOption: false,
        },
        {
          title: 'Nee',
          feedback: `<p>Dit is het goede antwoord. Als je baarmoeder is weggehaald, kun je niet meer zwanger worden. Als je baarmoeder-slijmvlies is weggehaald, kun je nog wel zwanger worden. Maar dat is gevaarlijk voor jou en je baby. Gebruik daarom een voorbehoed-middel tot na de overgang.</p>`,
          correctOption: true,
        },
      ],
      button: 'Volgende',
    },
    {
      path: '/stap-8/vraag-5',
      routeId: 'P5-041',
      nextRouteId: 'P5-042',
      title:
        'Kun je meer pijn hebben als je ongesteld bent, nadat je baarmoeder-slijmvlies is weggehaald?',
      type: 'feedbackQuestion',
      feedbackAnswers: [
        {
          title: 'Ja',
          feedback: `<p>Dit is het goede antwoord. Bij sommige mensen wordt de pijn erger. Heb je normaal veel pijn als je ongesteld bent? Dan heb je een grotere kans dat de pijn erger wordt na de operatie.</p>`,
          correctOption: true,
        },
        {
          title: 'Nee',
          feedback: `<p>Het goede antwoord is ja. Bij sommige mensen wordt de pijn erger. Heb je normaal veel pijn als je ongesteld bent? Dan heb je een grotere kans dat de pijn erger wordt na de operatie.</p>`,
          correctOption: false,
        },
      ],
      button: 'Volgende',
    },
    {
      path: '/stap-8/vraag-6',
      routeId: 'P5-042',
      nextRouteId: 'P5-043',
      title: 'Heb je nooit meer bloedverlies na het weghalen van je baarmoeder?',
      type: 'feedbackQuestion',
      feedbackAnswers: [
        {
          title: 'Ja',
          feedback: `<p>Dit is het goede antwoord. Je wordt nooit meer ongesteld. Het bloedverlies stopt helemaal.</p>`,
          correctOption: true,
        },
        {
          title: 'Nee',
          feedback: `<p>Het goede antwoord is ja. Je wordt nooit meer ongesteld. Het bloedverlies stopt helemaal.</p>`,
          correctOption: false,
        },
      ],
      button: 'Volgende',
    },
    {
      path: '/stap-8/wat-is-voor-jou-belangrijk',
      routeId: 'P5-043',
      nextRouteId: 'P5-044',
      type: 'explanation',
      title: 'Wat is voor jou belangrijk? ',
      align: 'left',
      titleAlign: 'center',
      description: `
        <p>Je bepaalt samen met je arts welke behandeling voor jou het beste is. Dit hangt af van jouw situatie en wat jij belangrijk vindt.</p>
        <p>De uitspraken hieronder kunnen je helpen bij je keuze.</p>
      `,
      button: 'Volgende',
    },
    {
      path: '/stap-8/vraag-7',
      routeId: 'P5-044',
      nextRouteId: 'P5-045',
      title: 'Bloedverlies',
      type: 'uniqueQuestion',
      answers: [
        { title: 'Ik kan goed leven met mijn bloedverlies ' },
        { title: 'Ik heb veel last van mijn bloedverlies ' },
        { title: 'Geen mening' },
      ],
      button: 'Volgende',
    },
    {
      path: '/stap-8/vraag-8',
      routeId: 'P5-045',
      nextRouteId: 'P5-046',
      title: 'Buikpijn',
      type: 'uniqueQuestion',
      answers: [
        { title: 'Ik heb weinig last van buikpijn als ik ongesteld ben' },
        { title: 'Ik heb veel last van buikpijn als ik ongesteld ben' },
        { title: 'Geen mening' },
      ],

      button: 'Volgende',
    },
    {
      path: '/stap-8/vraag-9',
      routeId: 'P5-046',
      nextRouteId: 'P5-047',
      title: 'Kinderen',
      type: 'uniqueQuestion',
      answers: [
        { title: 'Ik wil in de toekomst nog graag kinderen' },
        { title: 'Ik wil geen kinderen (meer)' },
        { title: 'Geen mening' },
      ],
      button: 'Volgende',
    },
    {
      path: '/stap-8/vraag-10',
      routeId: 'P5-047',
      nextRouteId: 'P5-048',
      title: 'Ongesteld worden',
      type: 'uniqueQuestion',
      answers: [
        { title: 'Ik vind het niet erg om nog ongesteld te worden' },
        { title: 'Ik wil het liefst zo weinig mogelijk ongesteld worden' },
        { title: 'Geen mening' },
      ],
      button: 'Volgende',
    },
    {
      path: '/stap-8/vraag-11',
      routeId: 'P5-048',
      nextRouteId: 'P5-049',
      title: 'Operatie',
      type: 'uniqueQuestion',
      answers: [
        { title: 'Ik ben gespannen voor een operatie' },
        { title: 'Ik geloof dat een operatie wel goed zal gaan' },
        { title: 'Geen mening' },
      ],
      button: 'Volgende',
    },
    {
      path: '/stap-8/vraag-12',
      routeId: 'P5-049',
      nextRouteId: 'P5-050',
      title: 'Bijwerkingen',
      type: 'uniqueQuestion',
      answers: [
        { title: 'Ik maak me zorgen over de bijwerkingen van medicijnen' },
        { title: 'Ik geloof dat de bijwerkingen van medicijnen wel zullen meevallen ' },
        { title: 'Geen mening' },
      ],
      button: 'Volgende',
    },
    {
      path: '/stap-8/vraag-13',
      routeId: 'P5-050',
      nextRouteId: 'P5-051',
      title: 'Voorbehoed-middel',
      type: 'uniqueQuestion',
      answers: [
        { title: 'Ik ben op zoek naar een voorbehoed-middel' },
        { title: 'Ik heb geen voorbehoed-middel nodig' },
        { title: 'Geen mening' },
      ],
      button: 'Volgende',
    },
    {
      path: '/stap-8/vraag-14',
      routeId: 'P5-051',
      nextRouteId: 'P5-052',
      title: 'Overgang',
      type: 'uniqueQuestion',
      answers: [
        { title: 'Ik ben bijna in de overgang' },
        { title: 'Het duurt nog lang tot ik in de overgang kom' },
        { title: 'Geen mening' },
      ],
      button: 'Volgende',
    },
    {
      path: '/stap-8/vraag-15',
      routeId: 'P5-052',
      nextRouteId: 'P5-053',
      type: 'question',
      title: 'Wat verwacht je van een behandeling?',
      align: 'left',
      titleAlign: 'center',
      description: `
        <div style="text-align: left;">
          <p>Bijvoorbeeld:</p>
          <ul>
            <li>Minder bloedverlies</li>
            <li>Minder pijn</li>
            <li>Nog kinderen kunnen krijgen</li>
          </ul>
          <p>Dit kun je hier invullen.</p>
        </div>
      `,
      questions: [
        {
          type: 'textarea',
        },
      ],
      button: 'Volgende',
    },
    {
      path: '/stap-8/vraag-16',
      routeId: 'P5-053',
      nextRouteId: 'P5-054',
      type: 'question',
      title: 'Welke behandelingen heb je al geprobeerd?',
      questions: [
        {
          type: 'multiple',
          answers: [
            { title: 'Geen behandeling', deselectOthers: true },
            { title: 'Medicijnen zonder hormonen' },
            { title: 'De pil om niet zwanger te worden ' },
            { title: 'Hormoonspiraal' },
            { title: 'Operatie: baarmoeder-slijmvlies weghalen' },
          ],
        },
      ],
      button: 'Volgende',
    },
    {
      path: '/stap-8/vraag-17',
      routeId: 'P5-054',
      nextRouteId: 'P5-055',
      type: 'question',
      title: 'Wat wil jij?',
      subtitle: 'Vraag',
      description: `
        <p>Je hebt nagedacht over de verschillende behandelingen voor veel bloedverlies als je ongesteld bent. Misschien weet je al wat je wilt. Vink aan welke behandelingen je misschien zou willen.</p>
      `,
      descriptionAlign: 'left',
      questions: [
        {
          type: 'multiple',
          answers: [
            {
              title: 'Niet behandelen',
            },
            {
              title: 'Medicijnen zonder hormonen',
            },
            {
              title: 'De pil om niet zwanger te worden',
            },
            {
              title: 'Hormoonspiraal',
            },
            {
              title: 'Operatie: weghalen van het baarmoeder-slijmvlies',
            },
            {
              title: 'Operatie: baarmoeder weghalen',
            },
            {
              title: 'Ik weet het nog niet',
            },
          ],
        },
      ],
      showTextArea: true,
      textAreaLabel: 'Vul hier in waarom jij dit het liefste wilt.',
      button: 'Ga verder',
    },
    {
      path: '/stap-8/vraag-18',
      routeId: 'P5-055',
      nextRouteId: 'P5-056',
      title: 'Weet je genoeg over de voordelen en nadelen van de verschillende behandelingen?',
      type: 'uniqueQuestion',
      answers: [{ title: 'Ja' }, { title: 'Nee' }, { title: 'Ik weet het niet zeker' }],
      button: 'Ga verder',
    },
    {
      path: '/stap-8/vraag-19',
      routeId: 'P5-056',
      nextRouteId: 'P5-057',
      title: 'Weet je wat voor jou het belangrijkste is?',
      type: 'uniqueQuestion',
      answers: [{ title: 'Ja' }, { title: 'Nee' }, { title: 'Ik weet het niet zeker' }],
      button: 'Ga verder',
    },
    {
      path: '/stap-8/vraag-20',
      routeId: 'P5-057',
      nextRouteId: 'P5-058',
      title: 'Vind je dat je een goede beslissing kunt nemen, samen met je zorgverlener?',
      type: 'uniqueQuestion',
      answers: [{ title: 'Ja' }, { title: 'Nee' }, { title: 'Ik weet het niet zeker' }],
      button: 'Ga verder',
    },
    {
      path: '/stap-8/vraag-21',
      routeId: 'P5-058',
      nextRouteId: 'P5-060',
      type: 'question',
      title: 'Heb je nog zorgen of vragen? ',
      description: `
        <p>Zijn er nog andere dingen onduidelijk? Dit kun je hier invullen en bespreken met je arts.</p>
      `,
      descriptionAlign: 'left',
      questions: [
        {
          type: 'textarea',
        },
      ],
      button: 'Volgende',
    },
    {
      path: '/print-overview',
      routeId: 'P5-060',
      nextRouteId: 'end',
      type: 'end',
      header: {
        subtitle: 'Einde keuzehulp',
        title: 'Alsjeblieft, je antwoorden bij deze keuzehulp',
        description: `
          <div>
            <p>Je bent nu klaar met het invullen van de keuzehulp. Bespreek je antwoorden op de keuzehulp met je arts. Samen kiezen jullie de behandeling die het beste bij je past.</p>

            <h2 style="margin-bottom: 0;">Jouw antwoorden</h2>
            <p style="margin-top: 0;">Je kunt je antwoorden bewaren. Zo kun je alles nog eens nalezen en bespreken met je partner, familie of vrienden.</p>
          </div>
        `,
        info: [
          {
            urlText: 'Meer informatie ',
            title: 'Meer informatie',
            content: `<div>
              <p>Meer informatie over veel bloedverlies als je ongesteld bent en de behandelingen:
                <ul>
                  <li><a href="https://www.bekkenbodem4all.nl/aandoeningen/aandoeningen-a-tot-z/hevig-bloedverlies-tijdens-de-menstruatie/" target="_blank">Bekkenbodem4All</a> is de patiënten-organisatie voor patiënten met bekkenbodem-klachten en klachten van de baarmoeder, eierstokken, eileiders en vagina. Ze kunnen je ook helpen bij contact met andere mensen met veel bloedverlies.</li>
                  <li><a href="https://www.thuisarts.nl/ongesteld-en-veel-bloedverlies" target="_blank">Thuisarts.nl</a>: informatie over veel bloedverlies als je ongesteld bent. Deze teksten zijn van Thuisarts.nl, geschreven in begrijpelijke taal.</li>
                  <li><a href="https://www.degynaecoloog.nl/informatiefilms/veel-bloedverlies-tijdens-de-ongesteldheid/" target="_blank">DeGynacoloog</a>:  informatie-films over de behandeling van veel bloedverlies als je ongesteld bent. Deze films zijn gemaakt met hulp van artsen die veel weten van de baarmoeder (gynaecologen).</li>
                  <li><a href="https://www.thuisarts.nl/file/2672/download" target="_blank">Deze keuzekaart</a> geeft een overzicht van de voordelen en nadelen van elke behandeling.</li>
                </ul>
              </p>

              <p>Meer informatie over samen beslissen:
                <ul>
                  <li><a href="https://begineengoedgesprek.nl/" target="_blank">Begineengoedgesprek.nl</a></li>
                  <li><a href="https://3goedevragen.nl" target="_blank">3goedevragen.nl</a></li>
                  <li><a href="https://watertoedoet.info/" target="_blank">Watertoedoet.info</a></li>
                </ul>
              </p>
            </div>`,
          },
        ],
      },
    },
  ],
}

export default hevigMenstrueelBloedverlies
